export default "__VITE_ASSET__201e2ee2__"